"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validUsageContext = void 0;
const commons_objects_1 = require("@deliverr/commons-objects");
exports.validUsageContext = (0, commons_objects_1.stringEnum)(["PARCEL", "ZONE_SKIPPING"]);
//# sourceMappingURL=NetworkNode.js.map